import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { fetchAccountTypesSuccess, fetchAccountTypesError, FETCH_ACCOUNT_TYPES } from './actions';

export const fetchAccountTypesEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_ACCOUNT_TYPES),
    flatMap(() =>
      ajax
        .getJSON('/content/workplace/en/participant/ri/content-pages/account-types.model.json')
        .pipe(
          map((res: any) => {
            const itemsRoot = res[`:items`]?.root[`:items`];
            if (!itemsRoot) {
              throw new Error('===> Root items not found');
            }

            const contentFragmentListKey = Object.keys(itemsRoot)
              .find(key => key.startsWith('contentfragmentlist'));

            if (contentFragmentListKey) {
              return fetchAccountTypesSuccess(itemsRoot[contentFragmentListKey].items);
            } else {
              throw new Error('Content Fragment List not found ===> ');
            }
          }),
          catchError(ex => {
            console.error('Error: ===> ', ex);  // Logging errors
            return of(fetchAccountTypesError(ex));
          }),
        ),
    ),
  );